export const adaptEstadoSolicitudIndicacion = (estadoData) => {
    return {
        id: estadoData?.idEstadoIndicacionAprobacion,
        displayName: estadoData?.descripcion,
        name: estadoData?.descripcion
    }
}

export const adaptEstadosSolicitudIndicacionArray = (
    estado
) => {   
    return structuredClone(estado?.estadosIndicacionAprobacion.valorEsperado)
        ?.map(estado => adaptEstadoSolicitudIndicacion(estado));
}